import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserAccess } from '../../context/UserAccessContext';
import { useHubupCommunities } from '../../context/HubupCommunitiesContext';
import HubupNoCommunityModal from '../../components/HubupNoCommunityModal';

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">
    Chargement...
  </div>
);

export default function HubupEntry() {
  const { user } = useUserAccess();
  const { communities, loading, error, noAssignment, refetch } = useHubupCommunities();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
  };

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background">
        <HubupNoCommunityModal
          variant="error"
          message={error}
          onRetry={refetch}
          onLogout={handleLogout}
        />
      </div>
    );
  }

  if (communities.length > 0) {
    return (
      <Navigate to={`/hubup/g/${communities[0].id}/dashboard`} replace />
    );
  }

  const isAdmin = user?.permission === 'admin';
  let variant = 'mismatch';
  if (noAssignment) {
    variant = 'no-assignment';
  } else if (isAdmin) {
    variant = 'empty-admin';
  }

  return (
    <div className="min-h-screen bg-background">
      <HubupNoCommunityModal variant={variant} onLogout={handleLogout} />
    </div>
  );
}
